import { Flex, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useIntl } from 'react-intl'
import { FieldGroupBox, RuleStack, Tag, useFormStateContext } from 'ui'
import { MoreForLessTrigger } from '../../../../../../typings'
import { ItemsView } from '../../../../../ItemsView'
import { messages } from '../messages'
import styles from '../styles'

type Props = {
  name: string
  onRemove: () => void
  onEdit: () => void
}

export function ViewTrigger(props: Props) {
  const { name, onRemove, onEdit } = props
  const { form } = useFormStateContext()
  const { $t, formatNumber } = useIntl()

  const trigger: MoreForLessTrigger = useWatch({
    form,
    name,
  })
  const { minQuantity } = trigger

  if (minQuantity === undefined) return

  return (
    <Flex direction="column" className={styles.filledBox}>
      <Text>
        {$t(messages.trigger.description, {
          quantity: () => <Tag>{formatNumber(minQuantity)}</Tag>,
        })}
      </Text>
      <FieldGroupBox name={name} withBorder={false}>
        <RuleStack>
          <ItemsView config={trigger} onEdit={onEdit} onRemove={onRemove} />
        </RuleStack>
      </FieldGroupBox>
    </Flex>
  )
}
